import React, { useEffect, useState } from "react";
import "../../css/CRUDModal.css";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { formatDateToYYYYMMDD } from "../../helpers/DateHelpers";
import { useDispatch } from "react-redux";
import { setBalance } from "../store/balance/balanceSlice";

const creditsToRupees = (credits) => {
  if (credits === undefined || credits === null || credits === "") return "0.000";
  return (Number(credits) / 1000).toFixed(3);
};

const rupeesToCredits = (rupees) => {
  if (!rupees) return 0;
  return Number(rupees) * 1000;
};

const TopUpWhatsAppModal = ({
  show,
  handleClose,
  callApi,
  editData,
  action,
  columnData,
}) => {
  const loggedInUserName = sessionStorage.getItem("username");

  const [formData, setFormData] = useState({
    currentWaBalance: "",
    waTopUp: "",
    closingWaBalance: "",
  });

  const [errors, setErrors] = useState({
    currentWaBalance: "",
    waTopUp: "",
    closingWaBalance: "",
  });

  const dispatch = useDispatch();

  useEffect(() => {
    // Calculate closing balance whenever waTopUp changes
    setFormData((prev) => ({
      ...prev,
      closingWaBalance: prev.waTopUp
        ? (Number(creditsToRupees(columnData?.waBalance || 0)) + Number(prev.waTopUp || 0)).toFixed(3)
        : "",
    }));
  }, [formData.waTopUp, columnData]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    let updatedValue = value;

    setFormData((prev) => ({
      ...prev,
      [id]: updatedValue,
    }));
  };

  // Simple validation function
  const validate = () => {
    const newErrors = {};

    if (!formData.waTopUp) {
      newErrors.waTopUp = "WhatsApp Top Up is required";
    } else {
      if (!/^\d+$/.test(formData.waTopUp)) {
        newErrors.waTopUp = "Only numbers are allowed for WhatsApp Top Up";
      } else if (parseInt(formData.waTopUp, 10) <= 0) {
        newErrors.waTopUp = "Amount must be greater than zero";
      }
    }

    return newErrors;
  };

  const handleBlur = (e) => {
    const { id, value } = e.target;
    const fieldErrors = {};
    const trimmedValue = value?.trim();

    fieldErrors.waTopUp = "";

    if (!trimmedValue) {
      fieldErrors.waTopUp = "WhatsApp Top Up is required";
    } else {
      switch (id) {
        case "waTopUp":
          if (!/^\d+$/.test(trimmedValue)) {
            fieldErrors.waTopUp = "Only numbers are allowed for WhatsApp Top Up";
          } else if (parseInt(trimmedValue, 10) <= 0) {
            fieldErrors.waTopUp = "Amount must be greater than zero";
          }
          break;

        default:
          break;
      }
    }

    setErrors((prev) => ({
      ...prev,
      ...fieldErrors,
    }));
  };

  const handleBack = () => {
    handleClose();
    setErrors({});
  };

  const handleAddWaTopUp = () => {
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      const payload = {
        username: loggedInUserName,
        customerCode: columnData?.customerCode || "",
        waUnits: rupeesToCredits(Number(formData.waTopUp)) || 0,
      };

      axiosPostApi(apiList.CREATE_FREE_WA_TOPUP_REQUEST, payload)
        .then((response) => {
          if (response?.status === 200 && response?.data?.status === true) {
            CustomAlert({
              title: response?.data?.message || "WhatsApp Topup request added successfully",
              icon: "success",
              confirmButtonText: "OK",
              showCloseButton: true,
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                fetchDashboardData();
              }
            });
            callApi();
            handleClose();
          } else if (response?.status === 200 && !response?.data?.status) {
            CustomAlert({
              title: "Failed to Request",
              text: response.data.message,
              icon: "error",
              confirmButtonText: "Retry",
            });
          }
        })
        .catch((error) => {
          console.error("Error processing WhatsApp TopUp request:", error);
          CustomAlert({
            title: "Error",
            text: "An error occurred while adding the WhatsApp TopUp request. Please try again later.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        });
    }
  };

  const fetchDashboardData = () => {
    const endDate = formatDateToYYYYMMDD(new Date());
    const startDate1 = new Date(new Date().setDate(new Date().getDate() - 90));
    const finalStartDate = formatDateToYYYYMMDD(startDate1);

    const requestBody = {
      startDate: finalStartDate,
      endDate: endDate,
      username: loggedInUserName,
    };

    axiosPostApi(apiList.DASHBOARD_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          dispatch(setBalance(response?.data?.data?.balanceDetails));
          callApi(1);
        }
      })
      .catch((error) => {
        console.error("Error fetching SMS overview data", error);
      });
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1031,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "550px",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                }}
              >
                <h5 className="modal-title main-title">TopUp WhatsApp</h5>
              </div>
              <form>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "24px",
                  }}
                >
                  <div className="row mt-2 w-full">
                    <div className="col-12">
                      <div className="row mb-3">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor="currentWaBalance">
                              Current WhatsApp Balance (₹)
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="currentWaBalance"
                              placeholder="0"
                              value={creditsToRupees(columnData?.waBalance)}
                              style={{
                                textAlign: "right",
                                cursor: "not-allowed",
                              }}
                              readOnly={true}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-12">
                          <label htmlFor="waTopUp">WhatsApp Top Up (₹)</label>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control placeholder:text-sm"
                              id="waTopUp"
                              placeholder="Enter WhatsApp units to top up"
                              value={formData.waTopUp || ""}
                              style={{ textAlign: "right" }}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d{0,9}$/.test(value)) {
                                  handleInputChange(e);
                                }
                              }}
                              onBlur={handleBlur}
                              inputMode="numeric"
                            />
                            {errors.waTopUp ? (
                              <span className="error">{errors.waTopUp}</span>
                            ) : null}
                          </div>
                        </div>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor="closingWaBalance">
                              Closing WhatsApp Balance (₹)
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="closingWaBalance"
                              placeholder="0.00"
                              value={formData?.closingWaBalance || ""}
                              style={{
                                textAlign: "right",
                                cursor: "not-allowed",
                              }}
                              readOnly={true}
                            />
                          </div>
                        </div>
                      </div>

                      <hr />
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal mt-2"
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    padding: "12px",
                    paddingTop: "0px",
                    gap: "16px",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-back"
                    onClick={handleBack}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-submit"
                    onClick={handleAddWaTopUp}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TopUpWhatsAppModal;
